module.exports = new __parcel__URL__("edition-awareness-illustration.cf1dba8c.svg").toString();